export const apiStatisticPath = 'api-statistic';
